import axios from 'axios';
import _ from 'lodash';
import * as types from './actionTypes';
import * as urls from './urlTypes';
import { isStudyAvailable } from '../util/preferenceUtils';

export const updateModuleStudy = (moduleType, study, updatedWeightType) => ({
  type: types.UPDATE_MODULE_STUDY,
  study,
  moduleType,
  updatedWeightType,
});
export const updateCommonStudy = study => ({
  type: types.UPDATE_COMMON_STUDY,
  study,
});

export const updateWeightType = (moduleType, weightTypeObj) => ({
  type: types.UPDATE_WEIGHT_TYPES,
  payload: {
    moduleType,
    weightTypeObj,
  },
});

export const setTrendStudies = trendStudies => ({
  type: types.SET_TREND_STUDIES,
  trendStudies,
});
export const clearTrendStudies = () => ({
  type: types.CLEAR_TREND_STUDIES,
});

// Thunks - actions that return a function that accepts a dispatch
export function getStudies(uid, accountId) {
  const url = `${urls.ROOT_URL}/users/${uid}/${accountId}/si-studies`;
  return (dispatch, getState) => {
    return axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    })
      .then(response => {
        if (response.data && response.data.data.length > 0) {
          const userPreferences = getState().preferences ?
          _.cloneDeep(getState().preferences.userPreferences) : {};
          const permission = getState().userDetail ? getState().userDetail.permissions : {};

          if (userPreferences._ct._ds !== -1
            && !isStudyAvailable(userPreferences._ct._ds, '_ct', response.data.data, permission)) {
            userPreferences._ct._ds = -1;
          }
          if (userPreferences._qr._ds !== -1 &&
            !isStudyAvailable(userPreferences._qr._ds, '_qr', response.data.data, permission)) {
            userPreferences._qr._ds = -1;
          }
          if (userPreferences._dh._ds !== -1 &&
            !isStudyAvailable(userPreferences._dh._ds, '_dh', response.data.data, permission)) {
            userPreferences._dh._ds = -1;
          }
          if (userPreferences._st._ds !== -1 &&
            !isStudyAvailable(userPreferences._st._ds, '_st', response.data.data, permission)) {
            userPreferences._st._ds = -1;
          }
          dispatch({
            type: types.SET_PREFERENCES,
            payload: userPreferences,
          });
          dispatch({
            type: types.GET_STUDIES,
            payload: response.data,
            userPreferences: getState().preferences ? getState().preferences.userPreferences : {},
          });
          // dispatch({
          //   type: types.FILTER_STUDIES_BASED_ON_WEIGHT_TYPE,
          //   payload: response.data.data,
          // });
          // dispatch({
            // type: types.NO_ESSENTIALS_STUDIES,
            // payload: true,
          // });
          return true;
        }
        dispatch({
          type: types.NO_ESSENTIALS_STUDIES,
          payload: false,
        });
        return false;
      })
      .catch(response => console.warn(response));
  };
}

export function getLatestStudy(userId, accountId, studyRequest) {
  const url = `${urls.ROOT_URL}/users/${userId}/${accountId}/latest-studies`;
  return dispatch => {
    return axios({
      url,
      method: 'post',
      withCredentials: true,
      responseType: 'json',
      data: studyRequest,
    })
    .then(response => {
      dispatch({
        type: types.GET_LATEST_STUDIES,
        payload: response.data.data,
      });
    })
    .catch(response => console.warn(response));
  };
}

export function getFootNotes(moduleType, productNo) {
  const url = `${urls.ROOT_URL}/users/fetchfootnotes/${productNo}`;
  return dispatch => {
    return axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    })
    .then(response => {
      if (response.data && response.data.data.length > 0) {
        dispatch({
          type: types.GET_FOOTNOTES,
          payload: response.data.data,
          moduleType,
        });
      }
    })
    .catch(response => console.warn(response));
  };
}